import { useEffect, useState, useCallback, useMemo } from 'react'

const useBillingMacroForm = ({ setVisible, isNew, macro = {}, setMacro, macros = [], setMacros, index }) => {
  const [macroName, setMacroName] = useState(macro.name || '')

  useEffect(() => {
    const tmpMacro = isNew
      ? {
          isActive: true,
          name: '',
          items: [{ type: undefined, code: undefined, name: undefined, icd10: undefined, qty: 0 }]
        }
      : {
          ...macro,
          items: [...macro.items, { type: undefined, code: undefined, name: undefined, icd10: undefined, qty: 0 }]
        }

    setMacro(tmpMacro)
    setMacroName(tmpMacro.name)
    // eslint-disable-next-line
  }, [])

  const handleOk = () => {
    const tmpMacros = JSON.parse(JSON.stringify(macros))
    let tmpMacro = JSON.parse(JSON.stringify(macro))
    tmpMacro.items.splice(tmpMacro.items.length - 1)
    if (isNew) {
      tmpMacros.push(tmpMacro)
      setMacros([...tmpMacros])
    } else {
      tmpMacros[index] = tmpMacro
      setMacros([...tmpMacros])
    }
    setVisible(false)
    // eslint-disable-next-line
  }

  const handleCancel = useCallback(() => {
    setVisible(false)
    setMacro({ isActive: true, name: '', items: [] })
    // eslint-disable-next-line
  }, [])

  const handleFieldChange = useCallback(
    (field, value) => {
      setMacro((prevMacro) => ({ ...prevMacro, [field]: value }))
    },
    [setMacro]
  )

  const handleItemSelection = (items) => {
    setMacro((prevMacro) => ({ ...prevMacro, items }))
  }

  return useMemo(
    () => ({
      macroName,
      handleOk,
      handleCancel,
      handleFieldChange,
      handleItemSelection
    }),
    [macroName, handleCancel, handleFieldChange, handleItemSelection]
  )
}

export default useBillingMacroForm
